var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPowerButtonBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "power-button-blue",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.385,
    height: 14,
    viewBox: "0 0 13.385 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_51105",
    "data-name": "Path 51105",
    d: "M21.042,48.464a.517.517,0,0,0-.686.207.485.485,0,0,0,.213.663,5.474,5.474,0,0,1,3.041,4.878,5.68,5.68,0,0,1-11.354,0A5.469,5.469,0,0,1,15.3,49.336a.483.483,0,0,0,.213-.663.516.516,0,0,0-.686-.207,6.449,6.449,0,0,0-3.585,5.75,6.6,6.6,0,0,0,6.693,6.49,6.6,6.6,0,0,0,6.692-6.492,6.451,6.451,0,0,0-3.583-5.75Z",
    transform: "translate(-11.24 -46.705)",
    fill: "#03c4de"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51106",
    "data-name": "Path 51106",
    d: "M238.784,7.831V.652a.652.652,0,0,0-1.3,0V7.831a.652.652,0,0,0,1.3,0Z",
    transform: "translate(-231.439 0)",
    fill: "#03c4de"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPowerButtonBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/power_button_blue.86f714467704b7b960c38b5c11337816.svg";